




















































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import {
  IcoachCategories,
  IcoachCategoriesEnum,
  IcoachCategorySkill,
  IcoachDashboardInfo,
  IcoachGeneralInfo,
  MainLogosTypes
} from '@/interfaces'
import IcoachService from '@/services/IcoachService'
import IcoachLocalStorageHelper from '@/utils/IcoachLocalStorageHelper'
import Progress from '@/components/common/progressBar/Progress.vue'
import IcoachHelper from '@/utils/IcoachHelper'

@Component({
  name: 'DashboardPage',
  components: {
    Progress
  }
})
export default class DashboardPage extends Vue {
  @Prop({})
  icoachUserId!: number

  @Getter('icoach/getIcoachInfo')
  icoachInfo!: IcoachGeneralInfo | null

  icoachDashboardInfo: IcoachDashboardInfo | null = null
  activeIndex: IcoachCategories = IcoachCategoriesEnum.SOFT_SKILLS
  icoachTitle: string = ''
  error: string | null = null

  async created () {
    if (!IcoachLocalStorageHelper.hasIcoachUser(this.icoachUserId)) {
      this.$router.push({ name: 'notFound' })

      return
    }

    try {
      await this.uploadIcoachInfo()
    } catch (error) {
      if (error instanceof TypeError) {
        this.error = error.message
      } else {
        this.$router.push({ name: 'notFound' })
      }
    }
  }

  async uploadIcoachInfo () {
    const icoachUser = IcoachLocalStorageHelper.getIcoachUser(this.icoachUserId)

    if (icoachUser === null || icoachUser.icoachAccessCode === null) {
      throw new Error()
    }

    if (this.icoachInfo === null) {
      const response = await IcoachService.getIcoachCourseInfo(icoachUser.icoachAccessCode)

      this.$store.commit('mainLogo/setLogos', response.logos)
      this.$store.commit('mainLogo/setType', MainLogosTypes.ICOACH_LOGOS)
      this.$store.commit('icoach/setIcoachInfo', {
        'userId': this.icoachUserId,
        'icoachCourse': response
      })
    }

    this.icoachTitle = icoachUser.icoachCourseTitle
    this.activeIndex = icoachUser.icoachSkillCategoryId

    if (this.icoachInfo !== null) {
      IcoachHelper.checkIcoachCourse(this.icoachInfo.icoachCourse)
    } else {
      throw Error()
    }

    this.icoachDashboardInfo = await IcoachService.getIcoachDashboardInfo(icoachUser.icoachCourseId, icoachUser.icoachUserId)
  }

  completedSkills (category: IcoachCategorySkill[]) : number {
    let total: number = 0

    category.forEach((skill) => {
      if (skill.isCompleted) {
        total++
      }
    })

    return total
  }

  openSkill () {
    IcoachLocalStorageHelper.updateCurrentCategory(this.icoachUserId, this.activeIndex)
  }

  changeIndex (index: IcoachCategories) {
    this.activeIndex = index
  }
}
